<template>
  <div :class="['calendar-events', {loading: isLoading}]">
    <!-- <sort @option-selected="optionSelected"/> -->
    <div>
      <FullCalendar
        ref="fullCalendar"
        :plugins="calendarPlugins"
        :header="{
          left: 'prev',
          center: 'title',
          right: 'next',
        }"
        :customButtons="customButtons"
        :selectable="true"
        :fixedWeekCount="false"
        :eventLimit="false"
        :eventDataTransform="eventDataTransform"
        :eventRender="eventRender"
        @dateClick="dateClick"
        :events="events"
      />
    </div>
    <StLoading v-if="isLoading" />
  </div>
</template>

<script>
import $ from 'jquery'
import FullCalendar from '@fullcalendar/vue'
import DayGridPlugin from '@fullcalendar/daygrid'
import InteractionPlugin from '@fullcalendar/interaction'
// import sort from '@/components/artefacts/project/event-sort/sort'
import StLoading from '@/components/StLoading.vue'
import projectMixin from '../projectmixin.js'
import {mapState} from 'vuex'
import {store} from '../store-constituency'

export default {
  props: ['attributes'],
  mixins: [projectMixin],
  components: {
    FullCalendar, StLoading
  },
  computed: {
    ...mapState(['eventsdata', 'eventsondate', 'candidates', 'constituencies', 'parties']),
    fullCalendarAPI: function () {
      return this.$refs.fullCalendar.getApi()
    },
    currentConstituency () {
      return store.currentConstituency
    }
  },
  watch: {
    eventsdata: function (newVal, oldVal) {
      this.events = newVal
      setTimeout(() => {
        if (this.fullCalendarAPI) {
          this.fullCalendarAPI.render()
          this.fullCalendarAPI.rerenderEvents()
        }
      })
    },
    eventsondate: function (newVal, oldVal) {
      if (this.isLoading && newVal && newVal.length) {
        // window.scrollBy(0, 300)
        document.querySelector('.component.component-events').scrollIntoView({behavior: 'smooth', inline: 'center'})
      }
      this.isLoading = false
    },
    'currentConstituency.name': function (newVal, oldVal) {
      this.optionSelected({category: 'constituency', categoryvalue: newVal})
    }
  },
  data () {
    return {
      events: [],
      calendarPlugins: [
        InteractionPlugin,
        DayGridPlugin
      ],
      customButtons: {
        prev: {
          click: () => {
            this.isLoading = true
            setTimeout(() => {
              this.fullCalendarAPI.prev()
              this.updateEvents()
            })
          }
        },
        next: {
          click: () => {
            this.isLoading = true
            setTimeout(() => {
              this.fullCalendarAPI.next()
              this.updateEvents()
            })
          }
        },
        today: {
          text: 'Today',
          click: () => {
            this.isLoading = true
            setTimeout(() => {
              this.fullCalendarAPI.today()
              this.updateEvents()
            })
          }
        }
      },
      numCalendarEvents: 0,
      currentDateSelected: new Date(),
      selectOption: {},
      isLoading: false
    }
  },
  methods: {
    eventRender: function (info) {
      // event, el, view
      // alter event to display
      const startDate = (new Date(info.event.start)).setHours(0, 0, 0, 0)
      const today = (new Date()).setHours(0, 0, 0, 0)
      var newNode = document.createElement('span')
      info.el.replaceChild(newNode, info.el.childNodes[0])
      $(info.el).addClass('index-' + info.event.extendedProps.index)
      // if (info.event.extendedProps.constituency) {
      //   var constArr = info.event.extendedProps.constituency.split(',')
      //   constArr.forEach((consti) => {
      //     $(info.el).addClass('constituency-' + consti.trim())
      //   })
      // } else {
      // }
      $(info.el).addClass('constituency-' + (info.event.extendedProps.constituency || ''))
      if (startDate === today) {
        $(info.el).addClass('today')
      } else if (startDate > today) {
        $(info.el).addClass('future')
      }
      if (info.event.extendedProps.noun === 'happening now') {
        $(info.el).addClass('happening')
      }

      setTimeout(() => {
        // Wait until the last event then redraw custom icons
        if (this.numCalendarEvents === info.event.extendedProps.numInView) {
          this.isLoading = false
          // remove all altered event then redraw them
          $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item`).remove()
          // start redraw
          $('.fc-day-grid .fc-row .fc-content-skeleton').each(function (skel) {
            var row = this
            $(this).find('table tbody tr:first').clone().addClass('event-item').appendTo($(this).find('table tbody'))
            var rowSpanArr = new Array(7)
            $(this).find('.event-item td').each(function (i) {
              // know the rowspan for filling the event
              rowSpanArr[i] = +$(this).attr('rowspan')
              $(this).attr('o-rowspan', $(this).attr('rowspan'))
              $(this).attr('rowspan', '')
            })
            $(this).find('table tbody tr:not(:first):not(.event-item)').each(function (rowcount) {
              var trtds = $(this).find('td')
              var lasti2 = -1
              trtds.each(function (i) {
                if ($(this).attr('rowspan')) {
                  // rowspan is not always in the first row
                  var rspanCtr = lasti2 >= 6 ? 0 : lasti2 + 1
                  while (rspanCtr < 7 && rowSpanArr[rspanCtr]) {
                    rspanCtr++
                  }
                  rowSpanArr[rspanCtr] = +$(this).attr('rowspan')
                }
                var clones = $(this).children().clone()
                $(row).find(`table tbody tr.event-item td`).each(function (i2) {
                  var ospan = +(rowSpanArr[i2] || 0)
                  var itemLength = $(row).find('table tbody tr:not(.event-item)').length
                  if (trtds.length === 7 && i === i2) {
                    clones.appendTo($(this))
                    lasti2 = i2
                    return false
                  } else if (trtds.length !== 7 && (!ospan || ospan + rowcount < itemLength) && ((lasti2 < 0) || lasti2 < i2)) {
                    clones.appendTo($(this))
                    lasti2 = i2
                    return false
                  }
                })
              })
            })
          })
          // filter events based on selected options
          this.optionSelected(this.selectOption)
        }
      })
    },
    updateEvents () {
      // update events
      this.numCalendarEvents = 0
      var activeStart = this.fullCalendarAPI.view.activeStart
      var activeEnd = this.fullCalendarAPI.view.activeEnd
      var someEvents = this.fullCalendarAPI.getEvents().filter((eventData) => {
        var start = new Date(eventData.start)
        if (activeStart <= start && activeEnd >= start) {
          this.numCalendarEvents++
          eventData.setExtendedProp('numInView', this.numCalendarEvents)
          return true
        } else {
          eventData.setExtendedProp('numInView', 0)
        }
        return false
      })
      if (!someEvents || !someEvents.length) {
        this.isLoading = false
      }
    },
    eventDataTransform: function (eventData) {
      // break event if long events
      var start = new Date(eventData.start)
      var end = new Date(eventData.end || eventData.start)
      var duration = end - start
      var durationInDays = Math.floor(duration / 1000 / 60 / 60 / 24)
      if (this.fullCalendarAPI) {
        eventData.numInView = 0
        if (this.fullCalendarAPI.view.activeStart <= start && this.fullCalendarAPI.view.activeEnd >= start) {
          this.numCalendarEvents = this.numCalendarEvents + 1 + durationInDays
          eventData.numInView = this.numCalendarEvents
        }
        if (end && durationInDays > 0) {
          for (var ctr = durationInDays; ctr > 0; ctr--) {
            var newStart = new Date(end)
            newStart.setDate(end.getDate() + 1 - ctr)
            this.fullCalendarAPI.addEvent({
              ...eventData,
              id: eventData.index + '-' + (ctr + 1),
              start: newStart,
              end: null,
              numInView: this.numCalendarEvents - ctr
            })
          }
          eventData.end = null
        }
      }
      eventData.id = eventData.index
      return eventData
    },
    dateClick: function (info) {
      this.isLoading = true
      this.fullCalendarAPI.select(info.date)
      this.currentDateSelected = info.date
      this.getEventsBy({date: this.currentDateSelected, ...this.selectOption})
    },
    optionSelected: function (param) {
      this.selectOption = param
      this.getEventsBy({...this.selectOption, date: this.currentDateSelected})
      if (param.categoryvalue) {
        // filter events for the selected option
        $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event`).hide()
        // show default or no constituency
        $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event.constituency-`).show()
        var optionKey = param.categoryvalue.toLowerCase()
        if (param.category === 'party') {
          this.parties[optionKey].forEach((item) => {
            $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event.index-${item}`).show()
          })
        } else if (param.category === 'constituency') {
          if (this.constituencies[optionKey]) {
            this.constituencies[optionKey].forEach((item) => {
              $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event.index-${item}`).show()
            })
          }
        } else {
          this.candidates[optionKey].forEach((item) => {
            $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event.index-${item}`).show()
          })
        }
      } else {
        $(`.fc-day-grid .fc-row .fc-content-skeleton table tbody tr.event-item a.fc-event`).show()
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.fullCalendarAPI) {
        this.fullCalendarAPI.render()
      }
    })
  }
}
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";

.calendar-events {
  &.loading {
    opacity: 0.5;
  }
  .st-loading-container {
    background-color: transparent !important;
  }
}
.fc.fc-ltr {
  th, td {
    padding: 2px;
    border-width: 2px;
  }
  & , h2 {
    font-family: $font-CuratorRegular;
    font-size: 15px;
    text-transform: uppercase;
  }
  .fc-toolbar.fc-header-toolbar {
    margin-bottom: 0.5em;
  }
  .fc-button.fc-button-primary {
    background-color: transparent;
    border-color: transparent;
    color: #333;
    &:focus {
      box-shadow: unset;
    }
  }
  .fc-view {
    .fc-scroller.fc-day-grid-container {
      overflow-y: visible !important;
      min-height: 320px;
      @include breakpoint($d_small) {
        min-height: 430px;
      }
      @include breakpoint($d_medium) {
        min-height: 480px;
      }
      /* @include breakpoint($d_normal) {
        min-height: 600px;
      } */
    }
    .fc-row {
      .fc-day-header {
        background-color: #EFF3F4;
        font-size: 13px;
        padding: 5px;
      }
      .fc-bg {
        .fc-day {
          background-color: #FFF;
          &.fc-today {
            background-color: #e0e8eb;
          }
        }
      }
      .fc-highlight-skeleton {
        td.fc-highlight {
          background: #EFF3F4;
          opacity: 0.7;
        }
      }
      div.fc-content-skeleton > table {
        > thead {
          td.fc-day-top {
            font-size: 13px;
          }
        }
        > tbody > tr {
          &:not(.event-item) {
            opacity: 0.2;
            display: none;
            text-align: right;
          }
          &.event-item {
            td.fc-event-container {
              text-align: right;
              a.fc-event {
                display: inline-block;
                border-radius: 50%;
                font-size: 13px;
                width: 4px;
                height: 4px;
                color: #FFF;
                border-color: transparent;
                margin: 1x;
                padding: 0;
                background-color: rgba(12, 43, 87, 0.2);

                &.future {
                  background-color: rgba(12, 43, 87, 0.5);
                }
                &.today {
                  background-color: #0C2B57;
                  &.happening {
                    background-color: #D6445C;
                  }
                }
                &.hide-event {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
.fc-unthemed th, .fc-unthemed td, .fc-unthemed thead, .fc-unthemed tbody, .fc-unthemed .fc-divider, .fc-unthemed .fc-row, .fc-unthemed .fc-content, .fc-unthemed .fc-popover, .fc-unthemed .fc-list-view, .fc-unthemed .fc-list-heading td {
  border-color: #EFF3F4;
}

</style>
